import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Portal } from '../Portal/Portal';
import closeIcon from '@/assets/icons/close-icon.svg';
import './LogoutModal.scss';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LogoutModal = ({ isOpen, onClose }: LogoutModalProps) => {
  const { t } = useTranslation('common');

  useEffect(() => {
    if (isOpen) {
      // Calculate scrollbar width to prevent layout shift
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleLogout = () => {
    // Clear localStorage as per authentication implementation
    localStorage.removeItem('token');
    // Redirect to login page or handle logout as needed
    window.location.href = '/auth';
  };

  return (
    <Portal>
      <div className="modal-overlay">
        <div className="logout-modal-container">
          <button 
            className="logout-modal-container__close" 
            onClick={onClose}
            aria-label={t('userMenu.close')}
          >
            <img src={closeIcon} alt="" />
          </button>

          <div className="logout-modal-container__header">
            <h2 className="logout-modal-container__title">{t('userMenu.logoutModalTitle')}</h2>
          </div>
          
          <div className="logout-modal-container__content">
            <p>{t('userMenu.logoutConfirmation')}</p>
          </div>

          <div className="logout-modal-container__actions">
            <button 
              className="logout-modal-container__button logout-modal-container__button--cancel" 
              onClick={onClose}
            >
              {t('userMenu.cancel')}
            </button>
            <button
              className="logout-modal-container__button logout-modal-container__button--confirm"
              onClick={handleLogout}
            >
              {t('userMenu.logout')}
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default LogoutModal;
